import { render, staticRenderFns } from "./SubmissionInlineSignature.vue?vue&type=template&id=2a07f448&"
import script from "./SubmissionInlineSignature.vue?vue&type=script&lang=js&"
export * from "./SubmissionInlineSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports